// Fonctions pures de la liste des commentaires.

// Initiales d'un nom : la première lettre des deux premiers mots qui commencent
// par une lettre (les emojis des prénoms en base sont ignorés). « N D » à défaut.
export const initiales = (nom) => {
  const mots = String(nom || "")
    .trim()
    .split(/\s+/)
    .filter((mot) => /^\p{L}/u.test(mot));
  if (!mots.length) return "ND";
  return mots
    .slice(0, 2)
    .map((mot) => [...mot][0].toUpperCase())
    .join("");
};

// Un commentaire se modifie et se supprime par son auteur, ou par un administrateur.
export const peutModifierCommentaire = (utilisateur, role, commentaire) => {
  if (!commentaire) return false;
  if (role === "ADMIN") return true;
  return Boolean(utilisateur && utilisateur.id && utilisateur.id === commentaire.createdById);
};
